import React from 'react';
import { JobStatus } from 'services/encoder';
import { getAudioMarker, hasAudioMarkerWithMedia } from 'shared/helpers/markers';
import shared from './shared';

function getStatus({ episode, markers, mediaFile }) {
  const encoding = shared.getEncodingJob(markers);

  if (mediaFile.error) {
    return 'media-file-failed';
  }

  if (episode.pending || markers.pending || mediaFile.pending || (encoding && !encoding.status)) {
    return 'pending';
  }

  const marker = getAudioMarker(markers);
  const upload = shared.getPendingUpload(marker);
  if (upload) {
    if (upload.error) {
      return 'upload-failed';
    }

    return 'uploading';
  }

  if (encoding && encoding.status === JobStatus.Failed) {
    return 'encoder-failed';
  }

  if (
    encoding &&
    ![JobStatus.Completed, JobStatus.CompletedWithoutUpdate].includes(encoding.status)
  ) {
    return 'encoding';
  }

  if (hasAudioMarkerWithMedia(markers)) {
    return 'ok';
  }

  return 'missing';
}

const withStatus = BaseComponent => {
  const WrappedComponent = props => <BaseComponent {...props} status={getStatus(props)} />;
  WrappedComponent.displayName = `withStatus(${BaseComponent.displayName ||
    BaseComponent.name ||
    'Component'})`;
  return WrappedComponent;
};

export default withStatus;
